"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconBookmarkFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3 1C2.44772 1 2 1.44772 2 2V14C2 14.3844 2.22035 14.7348 2.56681 14.9013C2.91328 15.0678 3.32453 15.021 3.6247 14.7809L8 11.2806L12.3753 14.7809C12.6755 15.021 13.0867 15.0678 13.4332 14.9013C13.7797 14.7348 14 14.3844 14 14V2C14 1.44772 13.5523 1 13 1H3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M4 1C3.44772 1 3 1.44772 3 2V18C3 18.388 3.22446 18.741 3.57584 18.9056C3.92723 19.0702 4.3421 19.0166 4.64018 18.7682L10 14.3017L15.3598 18.7682C15.6579 19.0166 16.0728 19.0702 16.4242 18.9056C16.7755 18.741 17 18.388 17 18V2C17 1.44772 16.5523 1 16 1H4Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M5 1C4.44772 1 4 1.44772 4 2V22C4 22.3905 4.22734 22.7453 4.58214 22.9085C4.93694 23.0717 5.35428 23.0134 5.65079 22.7593L12 17.3171L18.3492 22.7593C18.6457 23.0134 19.0631 23.0717 19.4179 22.9085C19.7727 22.7453 20 22.3905 20 22V2C20 1.44772 19.5523 1 19 1H5Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M6.5 2C5.67157 2 5 2.67157 5 3.5V28.5C5 29.0659 5.31845 29.5836 5.8235 29.8388C6.32855 30.094 6.93424 30.0433 7.3898 29.7076L16 23.3632L24.6102 29.7076C25.0658 30.0433 25.6714 30.094 26.1765 29.8388C26.6816 29.5836 27 29.0659 27 28.5V3.5C27 2.67157 26.3284 2 25.5 2H6.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;